/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

xplenty.directive('shortcutsList', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./shortcuts-list.html'),

      replace: true,

      scope: {
        shortcuts: '=ngModel',
      },

      link(scope, element, attrs) {
        const groups = [];

        const groupsItems = _.groupBy(scope.shortcuts, function (shortcut) {
          return shortcut.category;
        });
        _.each(groupsItems, function (group) {
          groups.push({
            name: group[0].category,
            shortcuts: group,
          });
        });
        scope.groups = groups;
      },
    };
  },
]);
